import { render, staticRenderFns } from "./SmsTemplateEdit.vue?vue&type=template&id=3bdb7e5e&scoped=true"
import script from "./SmsTemplateEdit.vue?vue&type=script&lang=js"
export * from "./SmsTemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./SmsTemplateEdit.vue?vue&type=style&index=0&id=3bdb7e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdb7e5e",
  null
  
)

export default component.exports